import packageJson from '../../package.json'

const rawVersion = packageJson.version ?? '0.0.0'

/** Full semver label for UI, e.g. `v3.7.1` */
export function getAppVersionLabel(): string {
 return `v${rawVersion}`
}

/** Major-only label for compact UI, e.g. `v3` */
export function getAppVersionShortLabel(): string {
 const major = rawVersion.split('.')[0] ?? rawVersion
 return `v${major}`
}
